export default __webpack_public_path__ + "static/media/heart-white.7eb03241.svg";